import { Component, OnInit, Input } from '@angular/core';
import { Message } from 'primeng//api';
import { GeneralUtils, mobileNoPattern } from '../../general-utils';
import { DataRetrievalService } from '../../data-retrieval.service';

@Component({
  selector: 'app-new-registration-patient',
  templateUrl: './new-registration-patient.component.html',
  styleUrls: ['./new-registration-patient.component.scss']
})
export class NewRegistrationPatientComponent implements OnInit {

  @Input()
  set projectName(projectName: string) {
    this._projectName = projectName;
    this.clearFormInputs();
    this.getRegistrationDropdownOptions();
  }
  get projectName(): string {
    return this._projectName;
  }

  protected _projectName: string = null;

  disableSubmit = false;

  messages_1: Message[] = [];
  messages_2: Message[] = [];

  mobilePattern = mobileNoPattern;

  dropdownOptions: any = {
    preferredMessageDeliveryTime: [],
    culture: [],
    motivations: [],
    exercisePrescription: [],
    secretionLoadModule: [],
    smokingModule: [],
  };

  enteredFormInput: any = {
    preferredMessageDeliveryTime: null,
    culture: null,
    motivations: null,
    exercisePrescription: null,
    secretionLoadModule: null,
    smokingModule: null,

    programStartDate: null,
    preferredMobileNumber: null,
    confirmMobileNumber: null,
    preferredName: null,
    keySupportPerson1: null,
    keySupportPerson2: null,
  };

  constructor(protected dataRetrievalService: DataRetrievalService) { }

  ngOnInit() {}

  clearFormInputs() {

    this.enteredFormInput = {
      preferredMessageDeliveryTime: null,
      culture: null,
      motivations: null,
      exercisePrescription: null,
      secretionLoadModule: null,
      smokingModule: null,

      programStartDate: null,
      preferredMobileNumber: null,
      confirmMobileNumber: null,
      preferredName: null,
      keySupportPerson1: null,
      keySupportPerson2: null,
    };

  }

  getRegistrationDropdownOptions() {

    this.dataRetrievalService.getRegistrationDropdownOptions().subscribe(
      dropdownOptions => {
        this.dropdownOptions = dropdownOptions;
      }
    );

  }

  submitRegistration() {

    this.disableSubmit = true;
    this.messages_1 = [];
    this.messages_2 = [];
    this.messages_2.push({ severity: 'info', summary: 'Sending:', detail: 'Submitting registration, please wait...' });

    const registration = {
      programStartDate: GeneralUtils.convertDateToISODateString(this.enteredFormInput.programStartDate),
      mobile: this.enteredFormInput.preferredMobileNumber,
      messageDeliveryTime: this.enteredFormInput.preferredMessageDeliveryTime,
      culture: this.enteredFormInput.culture,
      name: this.enteredFormInput.preferredName,
      firstSupportName: this.enteredFormInput.keySupportPerson1,
      secondSupportName: this.enteredFormInput.keySupportPerson2,
      motivation: this.enteredFormInput.motivations,
      exercisePrescription: this.enteredFormInput.exercisePrescription,
      secretion: this.enteredFormInput.secretionLoadModule,
      smoking: this.enteredFormInput.smokingModule,
      timezone: 'Pacific/Auckland',
      userType: 'Patient',
      projectName: this.projectName,
      projectVersion: '1.0.0'
    };

    this.dataRetrievalService.postUserRegistrationDetails(registration).subscribe(
      response => {

        this.messages_1 = [];
        this.messages_2 = [];

        if (response !== null && response.hasOwnProperty('error')) {
          this.messages_2.push({ severity: 'info', summary: 'Error:', detail: 'Registration not submitted. ' + response.error });
        } else {
          this.messages_1.push({ severity: 'info', summary: 'Sent:', detail: 'Registration submitted. You can now enter a new participant registration.' });
          this.clearFormInputs();
          window.scrollTo(0, 0);
        }

        this.disableSubmit = false;

      },
      error => {

        this.messages_1 = [];
        this.messages_2 = [];

        this.messages_2.push({ severity: 'info', summary: 'Error:', detail: 'Registration not submitted. Unknown error.' });

        this.disableSubmit = false;

      }
    );

  }


  numberInputValidator(event: any) {
    GeneralUtils.numberInputValidator(event);
  }


}
